module.exports = __webpack_public_path__ + "sunsemweb/img/yb.9ba3ecea.png";